<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.level3'> {{$t('txt.nivel3')}}: {{this.level3.name}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update nivel3'])">
                <router-link v-if='this.level3' :to="{ name: 'editsubtype', params: { id: level3.id }}">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i v-bind:class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import Level3Service from '../../api-services/nivel3.service.js'

export default {
  name: 'viewsubtype',
  data () {
    return {
      level2: null,
      level1: null,
      level3: null,
      level1_selected: null,
      level2_selected: null
    }
  },
  methods: {
    getLevel () {
      Level3Service.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.level3 = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    showPifLabel (pif) {
      let PIF = parseInt(pif)
      switch (PIF) {
        case 0: return this.$t('placeholder.nuNecesitaPif')
        case 1: return this.$t('placeholder.necesitaPif')
      }
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.level3) ? this.level3.ord : null,
            icon: 'fas fa-sort-numeric-up'
          },
          {
            inputName: 'nivel1',
            labelName: this.$t('placeholder.categorie'),
            inputValue: (this.level3 && this.level3.nivel1) ? this.level3.nivel1.name : null,
            icon: 'fas fa-sitemap'
          },
          {
            inputName: 'nivel2',
            labelName: this.$t('placeholder.subcategorie'),
            inputValue: (this.level3 && this.level3.nivel2) ? this.level3.nivel2.name : null,
            icon: 'fas fa-sitemap'
          },
          {
            inputName: 'pif',
            labelName: this.$t('placeholder.pif'),
            inputValue: (this.level3) ? this.showPifLabel(this.level3.pif) : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.level3) ? this.level3.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.level3) ? this.level3.discount : null,
            icon: 'fas fa-money-bill-wave info-tool'
          },
          {
            inputName: 'addition_min',
            labelName: this.$t('placeholder.addition_min'),
            inputValue: (this.level3) ? this.level3.addition_min : null,
            icon: 'fas fa-percentage'
          },
          {
            inputName: 'addition_distribution',
            labelName: this.$t('placeholder.addition_distribution'),
            inputValue: (this.level3) ? this.level3.addition_distribution : null,
            icon: 'fas fa-percentage'
          },
          {
            inputName: 'addition_partner',
            labelName: this.$t('placeholder.addition_partner'),
            inputValue: (this.level3) ? this.level3.addition_partner : null,
            icon: 'fas fa-percentage'
          },
          {
            inputName: 'addition_retail',
            labelName: this.$t('placeholder.addition_retail'),
            inputValue: (this.level3) ? this.level3.addition_retail : null,
            icon: 'fas fa-percentage'
          }
        ]
      }
    }
  },
  mounted () {
    this.getLevel()
  }
}
</script>
